import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { deserializeArray, Toaster } from '@tokeet/tv3-platform'
import { map, tap } from 'rxjs/operators'
import * as R from 'ramda'
import { Template, TemplateAddRequest, TemplateResponse, TemplateType, TemplateUpdateRequest } from './template.model'

@Injectable()
export class TemplateService {
  constructor(private http: HttpClient, private toast: Toaster) {}

  all(): Observable<Template[]> {
    const url = '@api/template/all/'

    return this.http.get<TemplateResponse[]>(url).pipe(
      deserializeArray<Template>(Template),
      map((templates) =>
        R.filter(
          (t: Template) =>
            t.type !== TemplateType.Contract &&
            // t.type !== TemplateType.CustomBranding &&
            t.type !== TemplateType.InvoiceTemplate,
          templates
        )
      ) // we filter out Contract type as Signature app will handle it, and we filter out InvoiceTemplates
    )
  }

  get(templateId: string): Observable<Template> {
    const url = `@api/template/${templateId}`
    return this.http.get(url).pipe(map((response) => Template.deserialize(response)))
  }

  add(request: TemplateAddRequest, options = { silent: false }): Observable<Template> {
    const url = '@api/template/'

    return this.http.post(url, request).pipe(
      map((response) => Template.deserialize(response)),
      tap(() => {
        if (!options.silent) {
          this.toast.success($localize`Template created successfully.`)
        }
      })
    )
  }

  update(id: string, request: TemplateUpdateRequest): Observable<Template> {
    const url = `@api/template/update/${id}`

    return this.http.put(url, request).pipe(
      map((response) => Template.deserialize(response)),
      tap(() => this.toast.success($localize`Template updated successfully.`))
    )
  }

  delete(id: string): Observable<string> {
    const url = `@api/template/delete/${id}`

    return this.http.delete(url).pipe(
      map(() => id),
      tap(() => this.toast.success($localize`Template deleted successfully.`))
    )
  }
}
